export default __webpack_public_path__ + "static/media/acne.d9f8d2c5.svg";